import { useEffect } from 'react';
import { useRudderstackClient } from './rudderstack-provider';
export var RudderstackPageTracking = function (_a) {
    var identifyCallProps = _a.identifyCallProps, pageCallProps = _a.pageCallProps;
    var RudderstackClient = useRudderstackClient().RudderstackClient;
    useEffect(function () {
        if (!RudderstackClient)
            return;
        /**
         * Note: only include logged in user data to identify calls, we might wanna track
         * logged out anon  auth id in page calls
         */
        if (document.referrer) {
            var referrerUrl = new URL(document.referrer);
            var isAfterLoginOrSignup = (referrerUrl.pathname === '/auth/login' ||
                referrerUrl.pathname === '/signup') &&
                referrerUrl.searchParams.has('next_action');
            if (identifyCallProps.isLoggedIn && isAfterLoginOrSignup) {
                RudderstackClient === null || RudderstackClient === void 0 ? void 0 : RudderstackClient.identify(identifyCallProps.federatedId, {
                    federated_id: identifyCallProps.federatedId,
                });
            }
        }
        RudderstackClient === null || RudderstackClient === void 0 ? void 0 : RudderstackClient.page('', '', {
            rb_visitor_id: pageCallProps.rbVisitorId,
        });
    }, [RudderstackClient, pageCallProps, identifyCallProps]);
    return null;
};
